import { profileState } from "@/atoms/user/profile-state";
import { ButtonColor } from "@/common/enum/button-color";
import { formatCommasNumber } from "@/common/util/format-number-with-commas";
import { getShippingPriceText } from "@/common/util/get-shipping-price-text";
import { QuotePDFDownloadButton } from "@/components/button/QuotePDFDownloadButton";
import { Body14Regular } from "@/components/typography/Body14Regular";
import { Body16Strong } from "@/components/typography/Body16Strong";
import { QuoteDetailDto } from "@/types/dto/quote-detail-dto";
import { Button, Table } from "flowbite-react";
import React from "react";
import { useRecoilState } from "recoil";

interface Props {
  headersLength: number;
  data: QuoteDetailDto;
}

export const QuoteItemTableFooter: React.FC<Props> = ({
  headersLength,
  data,
}) => {
  const [profile, setProfile] = useRecoilState(profileState);

  if (!profile) {
    return null;
  }

  return (
    <Table.Row className="bg-white">
      <Table.Cell colSpan={headersLength}>
        <div className="flex justify-between p-[16px] items-center">
          <QuotePDFDownloadButton quoteDetail={data} profile={profile}>
            <Button size="sm" color={ButtonColor.TRANSPARENT_OUTLINE}>
              견적서 저장
            </Button>
          </QuotePDFDownloadButton>
          <div className="flex flex-col gap-[2px]  items-end">
            <Body14Regular className="text-semantic-text-tertiary">
              {`정가 ${formatCommasNumber(
                data.originalPriceSum
              )} - 기본 할인 ${formatCommasNumber(
                data.discountPriceSum
              )} - 인센티브 할인 ${formatCommasNumber(
                data.incentiveDiscountPriceSum
              )} + 배송비 ${getShippingPriceText(data.shippingPrice)}`}
            </Body14Regular>
            <Body16Strong className="text-semantic-text-body">
              {`총 금액 (VAT 포함) ${formatCommasNumber(data.finalPriceSum)}원`}
            </Body16Strong>
          </div>
        </div>
      </Table.Cell>
    </Table.Row>
  );
};
